import { Grid, Typography } from '@mui/material'

// App Components
import { Page } from 'src/admin/core/components'

// Hooks
import { useAppTranslation, useUserClaimActions } from 'src/admin/core/hooks'
import { ClaimActions } from 'src/admin/core/models'

// Context & Components
import { FinancialFlowsProvider, useFinancialFlows } from './context'
import { ReportTypeTabs, Filters, ReportDataTable } from './components'

/**
 * Inner component that uses the context
 */
const FinancialFlowsContent = () => {
  const { label } = useAppTranslation()
  const { selectedReportType, reportDataLoading, searchReportData } = useFinancialFlows()

  const handleSearch = () => {
    searchReportData()
  }

  return (
    <Grid container spacing={2} sx={{ mt: 0.5 }}>
      <Grid item xs={12}>
        <ReportTypeTabs />
      </Grid>

      <Grid item xs={12}>
        <Filters onSearch={handleSearch} isLoading={reportDataLoading} />
      </Grid>

      <Grid item xs={12}>
        <ReportDataTable />
      </Grid>
    </Grid>
  )
}

/**
 * Main Financial Flows page component
 */
const FinancialFlows = () => {
  const { validateClaimActions } = useUserClaimActions()

  const actions = validateClaimActions('dashboard.sales-profit', [ClaimActions.CanPrint])

  return (
    <Page
      hasAccess={actions.canPrint}
    >
      <FinancialFlowsProvider>
        <FinancialFlowsContent />
      </FinancialFlowsProvider>
    </Page>
  )
}

export default FinancialFlows
